import '../../../shared/styles/Sidebar';
import '../../styles/Sidebar';
import React, { PropTypes } from 'react';
import sidebar from '../../../shared/js/lib/sidebar';
import SidebarAccordion from '../../../shared/js/components/SidebarAccordion';
import SidebarItem from '../../../shared/js/components/SidebarItem';
import { authTools } from '../../../shared/js/lib/authTools';
import { GLOBAL_ADMIN } from '../../../shared/js/lib/roles';

let Sidebar = React.createClass({
	propTypes: {
		currentObservation: PropTypes.object,
		currentPath: PropTypes.string.isRequired,
		user: PropTypes.object.isRequired
	},

	getInitialState: function() {
		return {
			openAccordion: 'observations'
		};
	},

	componentDidMount: function() {
		Object.keys(this.componentRefs).map((refName) => {
			if (this.componentRefs[refName].props.isActive) {
				this.setState({ openAccordion: refName });
			}
		});

		this.animateAccordions();
	},

	componentDidUpdate: function() {
		this.animateAccordions();
	},

	componentRefs: [],

	animateAccordions: function() {
		// For some reason, jQuery is undefined here sometimes for the QA team.  It may be a slow internet issue, but I've been unable
		// to recreate it, even when throttling my connection artificially.  This is most likely a side effect of the way we're
		// loading jQuery outside the bundle.  That's necessary to use the Bootstrap JS outside the bundle, which is a lot easier
		// than loading it via npm.  It's a general mess that I've never really found a great solution to.
		let waitForJquery = setInterval(() => {
			if (typeof $ !== 'undefined') {
				clearInterval(waitForJquery);
				$(function() {
					$('.sidebar-accordion:not(.open) .sidebar-accordion-content').slideUp(250);
					$('.sidebar-accordion.open .sidebar-accordion-content').slideDown(250);
				});
			}
		}, 20);
	},

	isOnPath: function(pattern) {
		if (this.props.currentPath.match(pattern)) {
			return true;
		} else {
			return false;
		}
	},

	isInObservations: function() {
		return (
			this.isOnPath(/^\/observations/) ||
			this.isOnPath(/^\/scores/)
		);
	},

	toggleAccordion: function(accordionName) {
		if (this.state.openAccordion === accordionName) {
			this.setState({ openAccordion: '' });
		} else {
			this.setState({ openAccordion: accordionName });
		}
	},

	render: function() {
		return (
			<div className="sidebar">
				<SidebarItem
					iconClass="fas fa-tachometer-alt"
					isActive={ this.isOnPath(/^\/$/) }
					title="Dashboard"
					targetUrl="/"
				/>
				<SidebarAccordion
					ref={ (element) => this.componentRefs.observations = element }
					header="Observations"
					iconClass="fas fa-eye"
					isActive={ this.isInObservations() }
					isOpen={ this.state.openAccordion === 'observations' }
					onClick={ (ev) => {
						this.toggleAccordion('observations');
					} }
				>
					<SidebarItem
						iconClass="fas fa-plus"
						isActive={ this.isOnPath(/^\/observations\/new/) }
						title="New observation"
						targetUrl="/observations/new"
					/>
					{
						this.props.currentObservation ? (
							<SidebarItem
								iconClass="fas fa-arrow-right"
								isActive={ this.isOnPath(/^\/observations\/current/) }
								title="Continue your observation"
								targetUrl="/observations/current"
							/>
						) : null
					}
					<SidebarItem
						iconClass="fas fa-plus-circle"
						isActive={ this.isOnPath(/^\/observations\/reliability/) }
						title="Scored reliability observation"
						targetUrl="/observations/reliability"
					/>
					<SidebarItem
						iconClass="fas fa-medal"
						isActive={ this.isOnPath(/^\/scores/) }
						title="Reliability scores"
						targetUrl="/scores"
					/>
				</SidebarAccordion>
				<SidebarAccordion
					ref={ (element) => this.componentRefs.reports = element }
					header="Reports"
					iconClass="fas fa-chart-pie"
					isActive={ this.isOnPath(/\/reports\//) }
					isOpen={ this.state.openAccordion === 'reports' }
					onClick={ () => this.toggleAccordion('reports') }
				>
					<SidebarItem
						iconClass="fas fa-file-download"
						isActive={ this.isOnPath(/\/reports\/export/) }
						title="Export observation data"
						targetUrl="/reports/export"
					/>
				</SidebarAccordion>
				{
					authTools.hasRoleOfAtLeast(GLOBAL_ADMIN, this.props.user) ? (
						<SidebarAccordion
							header="Admin"
							ref={ (element) => this.componentRefs.admin = element }
							iconClass="fas fa-users-cog"
							isActive={ this.isOnPath(/\/admin\//) }
							isOpen={ this.state.openAccordion === 'admin' }
							onClick={ () => this.toggleAccordion('admin') }
						>
							<SidebarItem
								iconClass="fas fa-trophy"
								isActive={ this.isOnPath(/\/admin\/standards/) }
								title="Gold standards"
								targetUrl="/admin/standards"
							/>
						</SidebarAccordion>
					) : ''
				}
				<div className="sidebar-curtain" onClick={ sidebar.toggle } />
			</div>
		);
	}
});

module.exports = Sidebar;



// WEBPACK FOOTER //
// ./frontend/olos/js/components/Sidebar.jsx